// Centralized animation constants for framer-motion.
// Defined at module scope to avoid creating new object refs on every render.

export const EASE_ARVEN = [0.22, 1, 0.36, 1];

export const REVEAL_INITIAL = { opacity: 0, y: 16 };
export const REVEAL_INITIAL_LARGE = { opacity: 0, y: 18 };
export const REVEAL_ANIMATE = { opacity: 1, y: 0 };

export const REVEAL_TRANSITION_BASE = {
  duration: 0.85,
  ease: EASE_ARVEN,
};

export const CARD_TRANSITION_BASE = {
  duration: 0.7,
  ease: EASE_ARVEN,
};

export const HERO_IMG_INITIAL = { scale: 1.08, opacity: 0 };
export const HERO_IMG_ANIMATE = { scale: 1, opacity: 1 };
export const HERO_IMG_TRANSITION = { duration: 1.6, ease: EASE_ARVEN };

export const SCROLL_HINT_INITIAL = { opacity: 0, y: -4 };
export const SCROLL_HINT_ANIMATE = { opacity: 0.5, y: 4 };
export const SCROLL_HINT_TRANSITION = {
  duration: 2.4,
  repeat: Infinity,
  repeatType: "reverse",
  ease: "easeInOut",
};
